/**
*  CUBE COMMONS
*
* 	- On INIT :
* 		- Delcare 'cube' polyfills
*  	- Init 'cube' library
*
* 	- On DOM Ready :
*  	- Init commons behaviour (layout, navigation...)
*
*/

require('./polyfills/classlist');
require('./polyfills/node-element');
require('./polyfills/node-list');
require('./polyfills/numbers');
require('./polyfills/node-remove');
require('./polyfills/legacy');

// Bind it to 'global' (== 'window')
global.cube = Object.assign(window.cube || {}, require('./lib/libraries'));
// > 'window.cube' or 'cube' is now accessible everywhere


// DOM READY
document.addEventListener('DOMContentLoaded', function() {

  cube.$('html').classList.remove('no-js');
  cube.$('html').classList.add('js');

  // Init old "Navigation"
  if (document.getElementById('js-navigation') && document.querySelector('.m-header-main'))
  require('./layout/navigation').init();

  // Init new "Navigation"
  if (document.getElementById('js-navigation') && document.querySelector('.dkt-header'))
  require('./layout/navigation-v2').init();

  // Init "Help Center Chat Plugin"
  if ($('#myChatLinkContainer').length && !cube.ui.isMobile())
  require('./layout/header-help-center').init()

  // Init "Header my account"
  if (document.getElementById('header-my-account'))
  require('./layout/header-my-account').init()

  // Init "Collapse"
  if(document.querySelector('.js-collapse'))
  require('./layout/collapse').init()

  if ($('.js-product-sticker').length)
  require('./components/sticker-generator').init();

  if ($('.modalv2__toggler').length) {
    cube.modalV2();
  }

  if (cube.ui.isIos()){
    cube.$('html').classList.add('ios');
  }

});

// Custom event polyfill
(function() {
  if (typeof window.CustomEvent === "function") return false

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent("CustomEvent")
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})();



// WEBPACK FOOTER //
// ./src/modules-es5/commons/commons.js